
export default {
  methods: {
    HcGo(target, { isRouter = true, isOpen = false, query = {}, params = {} } = {}) {
      // 兜底：没传直接回首页
      if (!target) {
        return this.$router.push("/").catch(() => {});
      }

      // 1️⃣ Vue Router 跳转
      if (isRouter) {
        // 已经是对象（{ path / name / query / params }）
        if (typeof target === "object") {
          return this.$router.push(target).catch(() => {});
        }

        // 字符串 + query / params
        const route = { path: target };

        if (Object.keys(query).length) route.query = query;
        if (Object.keys(params).length) route.params = params;

        return this.$router.push(route).catch(() => {});
      }

      // 2️⃣ 原生跳转
      if (isOpen) {
        return window.open(target);
      }

      window.location.href = target;
    },
    HcBack() {
      //返回上一级如果不存在则返回到首页
      this.$router.go(-1) || this.$router.push("/");
    },
    // 购物车添加
    /** 判断登录，如果没登录直接跳登录 */
    async checkLogin() {
      const isLogin = this.$store.getters["user/isLogin"];
      if (!isLogin) {
        this.$hcToast.error("请先登录");
        setTimeout(() => {
          this.$router.push("/login");
        }, 500);
        return false;
      }
      return true;
    },

    /** 通用操作包装：防重复点击 + 弹框 */
    async handleCartAction(actionFn, successMsg = "操作成功") {
      if (this.cartBtnLock) return;
      this.cartBtnLock = true;

      try {
        await actionFn();
        this.$hcToast.success(successMsg);
      } catch (err) {
        console.error(err);
        this.$hcToast.error(err.message || "操作失败");
      } finally {
        this.cartBtnLock = false;
      }
    },
    /** 添加购物车 */
    async HcAddCart(item, number = 1) {
      if (!(await this.checkLogin())) return;
      // 如果这本 书的购买权限有要求 要验证 availableRegtypes: "1,2,3,4"
      if (item.availableRegtypes){
        if (!this.$store.getters["user/isRegtypeAvailable"](item.availableRegtypes)){
          this.$hcToast.error("此书暂无权购买");
          return;
        }

      }

        this.handleCartAction(
          () =>
            this.$store.dispatch("cart/addToCart", {
              bookId: item.id,
              number,
            }),
          "已加入书篮"
        );
    },

    /** 修改购物车数量 */
    async HcUpdateCart(item, number) {
      if (!(await this.checkLogin())) return;

      this.handleCartAction(
        () =>
          this.$store.dispatch("cart/updateCartItem", {
            bookId: item.id,
            number,
          }),
        "购物车数量已更新"
      );
    },

    /** 删除购物车商品 */
    async HcRemoveCart(item) {
      if (!(await this.checkLogin())) return;

      this.handleCartAction(() => this.$store.dispatch("cart/removeFromCart", item.id), "已从购物车移除");
    },

    /** 清空购物车 */
    async HcClearCart() {
      if (!(await this.checkLogin())) return;

      this.handleCartAction(() => this.$store.dispatch("cart/clearCart"), "购物车已清空");
    },
    // 替换图片
    HcGetImg(src) {
      const defaultImg = require("@/assets/mimages/nophoto.png");

      if (!src) return defaultImg;

      // 转字符串 + 去空格
      const str = String(src).trim();

      if (!str) return defaultImg;

      // 按逗号分割
      const list = str
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

      // 取第一张
      return list.length ? list[0] : defaultImg;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/global.js